import { useEffect, useRef } from "react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { toast } from "sonner";

export function NetworkBanner() {
  const isOnline = useNetworkStatus();
  const hasShownOffline = useRef(false);

  useEffect(() => {
    if (!isOnline && !hasShownOffline.current) {
      hasShownOffline.current = true;
      toast.warning("You're offline", {
        description: "Some features may not work",
        duration: 4000,
      });
    } else if (isOnline) {
      // Silent recovery - reset the flag, no notification
      hasShownOffline.current = false;
    }
  }, [isOnline]);

  return null;
}
